// LARINO sections — gallery, variants, AJAX cart, sticky bar, FAQ.
// Namespaced to `data-lr-*` hooks so it never touches Horizon's own behaviour.

(function () {
  'use strict';

  function init() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';
    var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js';

    /* ---------- Money ---------- */
    function formatMoney(cents) {
      var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
      var value = (Number(cents) / 100).toFixed(2);
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
    }

    /* ---------- Gallery ---------- */
    document.querySelectorAll('.lr-buy__gallery').forEach(function (gallery) {
      var main = gallery.querySelector('[data-lr-main-image]');
      var thumbs = gallery.querySelectorAll('.lr-thumb');
      if (!main || !thumbs.length) return;

      function preload() {
        thumbs.forEach(function (t) {
          var src = t.getAttribute('data-src');
          if (!src) return;
          var img = new Image();
          img.decoding = 'async';
          img.src = src;
        });
      }
      if ('requestIdleCallback' in window) {
        requestIdleCallback(preload, { timeout: 3000 });
      } else {
        window.setTimeout(preload, 800);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          if (!src) return;
          main.src = src;
          var alt = thumb.getAttribute('data-alt');
          if (alt) main.alt = alt;

          thumbs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-selected', 'true');
        });
      });
    });

    /* ---------- FAQ ---------- */
    document.querySelectorAll('.lr-faq__q').forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', String(!open));
      });
    });

    /* ---------- Variants ---------- */
    document.querySelectorAll('[data-lr-variant-picker]').forEach(function (picker) {
      var buy = picker.closest('[data-lr-buy]');
      if (!buy) return;
      var json = buy.querySelector('[data-lr-product-json]');
      if (!json) return;

      var product;
      try { product = JSON.parse(json.textContent); } catch (e) { return; }
      if (!product || !product.variants) return;

      var sectionId = buy.getAttribute('data-section-id');
      var sticky = sectionId
        ? document.querySelector('[data-lr-sticky][data-section-id="' + sectionId + '"]')
        : null;
      var scopes = [buy, sticky].filter(Boolean);
      var selects = picker.querySelectorAll('select');

      function apply(variant) {
        if (!variant) return;
        scopes.forEach(function (scope) {
          var input = scope.querySelector('[data-lr-variant-input]');
          if (input) input.value = variant.id;

          var now = scope.querySelector('[data-lr-price-now]');
          var was = scope.querySelector('[data-lr-price-was]');
          if (now) now.textContent = formatMoney(variant.price);
          if (was) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              was.textContent = formatMoney(variant.compare_at_price);
              was.style.display = '';
            } else {
              was.style.display = 'none';
            }
          }

          scope.querySelectorAll('[data-lr-add]').forEach(function (btn) {
            var label = btn.querySelector('[data-lr-btn-label]');
            if (variant.available) {
              btn.removeAttribute('disabled');
              if (label) label.textContent = btn.dataset.lrDefaultLabel || 'Add to cart';
            } else {
              btn.setAttribute('disabled', 'disabled');
              if (label) label.textContent = 'Sold out';
            }
          });
        });

        // Swap gallery to the variant image when it has one
        if (variant.featured_image && variant.featured_image.src) {
          var main = buy.querySelector('[data-lr-main-image]');
          if (main) main.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1600x$1$2');
        }
      }

      function find() {
        var chosen = [];
        selects.forEach(function (s) { chosen.push(s.value); });
        return product.variants.filter(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        })[0];
      }

      selects.forEach(function (s) {
        s.addEventListener('change', function () { apply(find()); });
      });
    });

    /* ---------- Cart ---------- */
    document.querySelectorAll('[data-lr-add]').forEach(function (btn) {
      var label = btn.querySelector('[data-lr-btn-label]');
      if (label) btn.dataset.lrDefaultLabel = label.textContent.trim();
    });

    function flash(btn, text, isError) {
      if (!btn) return;
      var label = btn.querySelector('[data-lr-btn-label]') || btn;
      var original = btn.dataset.lrDefaultLabel || label.textContent;
      label.textContent = text;
      if (!isError) btn.classList.add('is-added');
      window.setTimeout(function () {
        label.textContent = original;
        btn.classList.remove('is-added');
      }, 1600);
    }

    function refreshCount() {
      fetch(cartUrl)
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count, [data-lr-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {});
    }

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-lr-product-form]');
      if (!form) return;
      e.preventDefault();

      var data = new FormData(form);
      var btn = e.submitter || form.querySelector('[data-lr-add]');

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: data.get('id'), quantity: data.get('quantity') || 1 })
      })
        .then(function (res) {
          return res.json().then(function (body) { return { ok: res.ok, body: body }; });
        })
        .then(function (r) {
          if (!r.ok) throw new Error(r.body.description || 'Could not add to cart');
          refreshCount();
          flash(btn, 'Added ✓');
        })
        .catch(function () {
          flash(btn, 'Try again', true);
        });
    });

    var mock = 0;
    document.querySelectorAll('[data-lr-mock]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mock += 1;
        flash(btn, 'Added ✓');
      });
    });

    /* ---------- Sticky bar ---------- */
    var sticky = document.querySelector('[data-lr-sticky]');
    var buyBlock = document.querySelector('[data-lr-buy]');
    var hero = document.querySelector('.lr-hero');

    if (sticky && 'IntersectionObserver' in window) {
      // Show once the hero is out of view; hide again while the buy block is on screen.
      var heroPassed = !hero;
      var buyVisible = false;

      function update() {
        var show = heroPassed && !buyVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }

      if (hero) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            heroPassed = !en.isIntersecting && en.boundingClientRect.top < 0;
            update();
          });
        }, { threshold: 0 }).observe(hero);
      }

      if (buyBlock) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            buyVisible = en.isIntersecting;
            update();
          });
        }, { threshold: 0.25 }).observe(buyBlock);
      }
    }

    /* ---------- Reveal ----------
       Content is only ever hidden by JS, and a hard timeout un-hides anything
       the observer never reached, so copy can never be permanently invisible. */
    if (!reduceMotion && 'IntersectionObserver' in window) {
      var targets = document.querySelectorAll(
        '.lr-feature__media, .lr-feature__content, .lr-statement__panel, .lr-guarantee, .lr-review, .lr-compare__inner'
      );
      targets.forEach(function (el) { el.classList.add('lr-reveal'); });

      var obs = new IntersectionObserver(function (entries, o) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            o.unobserve(en.target);
          }
        });
      }, { threshold: 0.12 });

      targets.forEach(function (el) { obs.observe(el); });

      // Safety net: never leave content hidden.
      window.setTimeout(function () {
        targets.forEach(function (el) { el.classList.add('is-visible'); });
      }, 2500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
